import * as T from '@/core/configs/types'
import { ShipmentNote } from './note'
import { Order } from './order'
import { getYearsPrependOptions } from '../utils/date'
import { queryStackSlots } from '@/api/stack'
import { TypeDock, TypeStage } from './constant'
// import { Container } from './container'

export const ShipmentWorking = 'Working'
export const ShipmentShipping = 'Shipping'
export const ShipmentDelivered = 'Delivered'
export const ShipmentDeleted = 'Deleted'
export const ShipmentStatus = {
  ShipmentWorking,
  ShipmentShipping,
  ShipmentDelivered,
  ShipmentDeleted
}

export const ShipmentCreation = 'Create'
export const ShipmentUpdate = 'Update'
export const ShipmentModes = {
  ShipmentCreation,
  ShipmentUpdate
}

export const BolGoodsCntPerPagePerCol = 23
export const BolGoodsCntPerPage = BolGoodsCntPerPagePerCol * 2

export const PickUpInfo = {
  carrierName: {
    type: T.String,
    label: 'Carrier',
    key: 'carrierName'
  },
  driverName: {
    type: T.String,
    label: 'Driver',
    key: 'driverName'
  },
  driverPhone: {
    type: T.String,
    label: 'Phone',
    key: 'driverPhone'
  },
  driverEmail: {
    type: T.String,
    label: 'Email',
    key: 'driverEmail'
  },
  checkInDate: {
    type: T.Time,
    label: 'Check In Date',
    key: 'checkInDate'
  },
  timeIn: {
    type: T.Time,
    label: 'Time In Date',
    key: 'timeIn'
  },
  timeOut: {
    type: T.String,
    label: 'Time Out',
    key: 'timeOut'
  }
}

export const BillInfo = {
  addressId: {
    type: T.String,
    label: 'Address Id',
    key: 'addressId'
  },
  name: {
    type: T.String,
    label: 'Name',
    key: 'name'
  },
  address: {
    type: T.String,
    label: 'Address',
    key: 'address'
  },
  city: {
    type: T.String,
    label: 'City',
    key: 'city'
  },
  state: {
    type: T.String,
    label: 'State',
    key: 'state'
  },
  zip: {
    type: T.String,
    label: 'Zip',
    key: 'zip'
  },
  country: {
    type: T.String,
    label: 'Country',
    key: 'country'
  },
  instruction: {
    type: T.String,
    label: 'Instruction',
    key: 'instruction'
  }
}

export const Shipment = {
  id: {
    type: T.String,
    label: 'Shipment ID',
    key: 'id'
  },
  no: {
    type: T.String,
    label: 'Shipment No',
    key: 'no'
  },
  status: {
    type: T.Enum,
    label: 'Shipment Status',
    key: 'status',
    options: Object.values(ShipmentStatus)
  },
  pickUpInfo: {
    type: T.Ref,
    label: 'Pick Up',
    key: 'pickUpInfo',
    ref: PickUpInfo
  },
  stageId: {
    type: T.String,
    label: 'Stage Id',
    key: 'stageId'
  },
  stageNo: {
    type: T.String,
    label: 'Stage No',
    key: 'stageNo'
  },
  dockId: {
    type: T.String,
    label: 'Dock Id',
    key: 'dockId'
  },
  dockNo: {
    type: T.String,
    label: 'Dock No',
    key: 'dockNo'
  },
  sealNo: {
    type: T.String,
    label: 'Seal No',
    key: 'sealNo'
  },
  trailerNo: {
    type: T.String,
    label: 'Trailer No',
    key: 'trailerNo'
  },
  pickUpNo: {
    type: T.String,
    label: 'Pick Up#',
    key: 'pickUpNo'
  },
  hasFba: {
    type: T.Enum,
    label: 'Has FBA',
    key: 'hasFba',
    options: [...T.TrueOrFalseOptions]
  },
  palletCount: {
    type: T.String,
    label: 'Pallet Count',
    key: 'palletCount'
  },
  deliveryDate: {
    label: 'Delivery Date',
    type: T.Time,
    key: 'deliveredDate'
  },
  estDeliveredDate: {
    label: 'EST Delivery Date',
    type: T.Time,
    key: 'estDeliveredDate'
  },
  actualDeliveredDate: {
    label: 'Actual Delivery Date',
    type: T.Time,
    key: 'actualDeliveredDate'
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime'
  },
  notes: {
    type: T.Array,
    itemType: T.Ref,
    ref: ShipmentNote,
    label: 'Note',
    key: 'notes'
  },
  pickUpDate: {
    type: T.Time,
    label: 'Pick Up Date',
    key: 'pickUpDate'
  }
}

export const ShipmentForm = Object.fromEntries(
  [
    {
      ...Shipment.stageNo,
      span: 1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: []
    }
  ].map(one => [one.key, one])
)

const ShipmentStatusTagType = status => {
  switch (status) {
    case ShipmentDeleted:
      return 'danger'
    case ShipmentWorking:
      return 'primary'
    default:
      return 'info'
  }
}

export const ShipmentInfoPicks = [
  {
    label: 'Shipment No.',
    key: 'no',
    span: 1,
    type: T.Text
  },
  {
    label: 'Shipment Status',
    key: 'status',
    options: Object.values(ShipmentStatus),
    type: T.Tag,
    effect: 'plain',
    tagType: ShipmentStatusTagType,
    span: 1
  },
  {
    label: 'Pallet Count',
    key: 'palletIds.length',
    type: T.Text,
    span: 1
  },
  { ...Shipment.stageNo, type: T.Text, span: 1 },
  { ...Shipment.dockNo, type: T.Text, span: 1 },
  { ...Shipment.pickUpDate, type: T.Time, span: 1 },
  { ...Shipment.deliveryDate, type: T.Time, span: 1 },
  { ...Shipment.estDeliveredDate, type: T.Time, span: 1 },
  { ...Shipment.actualDeliveredDate, type: T.Time, span: 1 },
  { ...Shipment.createdTime, type: T.Time, span: 1 },
  { ...Shipment.updatedTime, type: T.Time, span: 1 }
]

export const ShipmentInfoModifyForm = Object.fromEntries(
  [
    {
      ...Shipment.trailerNo,
      span: 2,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.cleanString
    },
    // {
    //   ...Shipment.pickUpDate,
    //   span: 2,
    //   type: T.TimeSelect,
    //   example: '',
    //   default: '',
    //   value: '',
    //   validators: []
    // },
    {
      ...Shipment.deliveryDate,
      span: 2,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: []
    },
    {
      ...Shipment.estDeliveredDate,
      span: 2,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: []
    }
  ].map(one => [one.key, one])
)

export const ShipmentInfoWrapUp = T.generateWrapUp(ShipmentInfoPicks)

export const ShipmentBasicPicks = [
  {
    label: 'Shipment No.',
    key: 'no',
    span: 1,
    type: T.Text
  },
  {
    label: 'Shipment Status',
    key: 'status',
    options: Object.values(ShipmentStatus),
    type: T.Tag,
    effect: 'plain',
    tagType: ShipmentStatusTagType,
    span: 1
  },
  {
    label: 'Pallet Count',
    key: 'palletIds.length',
    type: T.Text,
    span: 1
  },
  { ...Shipment.stageNo, type: T.Text, span: 1 },
  { ...Shipment.dockNo, type: T.Text, span: 1 },
  { ...Shipment.sealNo, type: T.Text, span: 1 },
  { ...Shipment.trailerNo, type: T.Text, span: 1 },
  { ...Shipment.pickUpNo, type: T.Text, span: 1 },
  { ...Shipment.pickUpDate, type: T.Time, span: 1 },
  { ...Shipment.deliveryDate, type: T.Time, span: 1 },
  { ...Shipment.estDeliveredDate, type: T.Time, span: 1 },
  { ...Shipment.actualDeliveredDate, type: T.Time, span: 1 },
  {
    label: 'Reported At',
    key: 'reportedAt',
    type: T.Time,
    span: 1
  },
  { ...Shipment.createdTime, type: T.Time, span: 1 },
  { ...Shipment.updatedTime, type: T.Time, span: 1 }
]

export const ShipmentBasicWrapUp = T.generateWrapUp(ShipmentBasicPicks)

export const ShipmentPickUpInfoPicks = [
  {
    ...PickUpInfo.carrierName,
    span: 1,
    type: T.Text,
    key: 'pickUpInfo.carrierName'
  },
  {
    ...PickUpInfo.driverName,
    span: 1,
    type: T.Text,
    key: 'pickUpInfo.driverName'
  },
  {
    ...PickUpInfo.driverPhone,
    span: 1,
    type: T.Text,
    key: 'pickUpInfo.driverPhone'
  },
  {
    ...PickUpInfo.driverEmail,
    span: 1,
    type: T.Text,
    key: 'pickUpInfo.driverEmail'
  },
  {
    ...Shipment.trailerNo,
    span: 1,
    type: T.Text
  },
  {
    ...PickUpInfo.checkInDate,
    span: 1,
    type: T.Time,
    key: 'pickUpInfo.checkInDate'
  }
]

export const ShipmentPickUpInfoModifyForm = Object.fromEntries(
  [
    {
      ...Shipment.pickUpNo,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.cleanString
    },
    {
      ...Shipment.trailerNo,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.cleanString
    },
    {
      ...PickUpInfo.carrierName,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.cleanString
    },
    {
      ...PickUpInfo.driverName,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.cleanString
    },
    {
      ...PickUpInfo.driverPhone,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.cleanString
    },
    {
      ...PickUpInfo.driverEmail,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.cleanString
    },
    {
      ...PickUpInfo.checkInDate,
      span: -1,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: []
    },
    {
      ...PickUpInfo.timeIn,
      span: -1,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: []
    }
  ].map(one => [one.key, one])
)

export const ShipmentPickUpInfoWrapUp = T.generateWrapUp(
  ShipmentPickUpInfoPicks
)

export const ShipmentTableHeaders = [
  {
    type: T.Link,
    label: 'Shipment#',
    key: 'no',
    link: 'goToShipmentDetail',
    sortable: 'custom',
    defaultSort: true,
    defaultOrder: T.Descending,
    col: 'shipment_no',
    linkKey: 'no',
    width: 90
  },
  {
    label: 'Status',
    key: 'status',
    options: Object.values(ShipmentStatus),
    type: T.Tag,
    width: 50,
    effect: 'plain',
    tagType: ShipmentStatusTagType,
    sortable: 'custom',
    col: 'shipment_status'
  },
  {
    type: T.SlotType,
    key: 'palletCount',
    slotName: 'palletCount',
    label: 'Pallets',
    width: 60,
    sortable: 'custom',
    col: 'pallet_count'
  },
  {
    type: T.SlotType,
    key: 'loadedCount',
    slotName: 'loadedCount',
    label: 'Load',
    width: 60,
    sortable: 'custom',
    col: 'loaded_pallet_count'
  },
  {
    label: 'Dest',
    slotName: 'dest',
    type: T.SlotType,
    effect: 'plain'
  },
  {
    type: T.String,
    label: 'Stage',
    key: 'stageNo',
    sortable: 'custom',
    col: 'shipment_stage_no',
    width: 60
  },
  {
    type: T.String,
    label: 'Dock',
    key: 'dockNo',
    sortable: 'custom',
    col: 'shipment_dock_no',
    width: 60
  },
  {
    type: T.String,
    label: 'Seal#',
    key: 'sealNo',
    sortable: 'custom',
    col: 'seal_no'
  },
  {
    type: T.String,
    label: 'Trailer#',
    key: 'trailerNo',
    sortable: 'custom',
    col: 'trailer_no'
  }
]

export const ShipmentSearchForm = [
  {
    label: "Shipment No. (071304 whithout '-')",
    key: 'fuzzyShipmentNo',
    type: T.TextInput,
    inputAccept: 'number',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      if (!value) return ''
      return header.prependValue + value.slice(0, 4) + '-' + value.slice(4)
    },
    prepend: T.PrependSelect,
    prependValue: getYearsPrependOptions('S', '')[0].value,
    prependOptions: getYearsPrependOptions('S', '')
  },
  {
    label: 'RII Order NO.(after OTRII)',
    key: 'fuzzyRiiOrderNo',
    type: T.TextInput,
    example: 'OTRII2022110101',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      if (!value) return ''
      return header.prependValue + value
    },
    prepend: T.PrependText,
    prependValue: 'OTRII'
  },
  {
    label: 'RII Container No.',
    key: 'fuzzyRiiContainerNo',
    type: T.TextInput,
    example: 'C-23-0190',
    inputAccept: 'number',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      if (!value) return ''
      return header.prependValue + value
    },
    prepend: T.PrependSelect,
    prependValue: getYearsPrependOptions('C')[0].value,
    prependOptions: getYearsPrependOptions('C')
  },
  {
    label: 'Container No.',
    key: 'fuzzyContainerNo',
    type: T.TextInput,
    example: 'RII-1234567',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    label: 'Destination (eg: ONT8)',
    key: 'address',
    type: T.AddressSelect,
    example: 'RII-1234567',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    ...Order.customer,
    key: 'fuzzyCustomer',
    type: T.TextInput,
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  }
]

export const ShipmentSearchParamsWrapUp = (status, searchForm) => {
  const search = T.DefaultWarpSearchForm(searchForm)
  search.addressId = search.address?.id
  search.statusList = [status]
  delete search.address
  return search
}

export const ThirdPartyBill = {
  name: {
    type: T.String,
    label: 'Name',
    key: 'name'
  },
  address: {
    type: T.String,
    label: 'Address',
    key: 'address'
  },
  city: {
    type: T.String,
    label: 'City',
    key: 'city'
  },
  state: {
    type: T.String,
    label: 'State',
    key: 'state'
  },
  country: {
    type: T.String,
    label: 'Country',
    key: 'country'
  },
  zip: {
    type: T.String,
    label: 'Zip',
    key: 'zip'
  },
  chargeTerm: {
    type: T.String,
    label: 'Charge Term',
    key: 'chargeTerm'
  }
}

export const ThirdPartyBillInfoPicks = [
  {
    ...ThirdPartyBill.name,
    span: 1,
    type: T.Text
  },
  {
    ...ThirdPartyBill.address,
    span: 1,
    type: T.Text
  },
  {
    ...ThirdPartyBill.city,
    span: 1,
    type: T.Text
  },
  {
    ...ThirdPartyBill.state,
    span: 1,
    type: T.Text
  },
  {
    ...ThirdPartyBill.country,
    span: 1,
    type: T.Text
  },
  {
    ...ThirdPartyBill.zip,
    span: 1,
    type: T.Text
  }
]

export const ThirdPartyBillInfoWrapUp = T.generateWrapUp(
  ThirdPartyBillInfoPicks
)

export const ThirdPartyBillInfoModifyForm = Object.fromEntries(
  [
    {
      ...ThirdPartyBill.name,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...ThirdPartyBill.address,
      span: -1,
      type: T.TextArea,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...ThirdPartyBill.city,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...ThirdPartyBill.state,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...ThirdPartyBill.country,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...ThirdPartyBill.zip,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    }
  ].map(one => [one.key, one])
)

export const ShipmentDockForm = [
  {
    ...Shipment.no,
    type: T.String,
    value: ''
  },
  {
    type: T.Checkbox,
    label: 'Same Stage Port',
    key: 'sameStagePort',
    activeText: 'Checked',
    value: false,
    default: false,
    validators: []
  },
  {
    ...Shipment.dockNo,
    span: 1,
    type: T.RemoteSelect,
    options: [],
    loading: false,
    method: function (name) {
      const that = this
      that.loading = true
      const query = {
        types: [TypeDock],
        size: -1
      }
      if (name) query.slotFuzzy = name
      queryStackSlots(query).then(res => {
        that.loading = false
        that.options.splice(0, that.options.length)
        that.options.push(
          ...res.records.map(item => ({
            key: item.no,
            label: item.no,
            value: item.no
          }))
        )
      })
    },
    default: '',
    value: '',
    validators: []
  }
]

export const ShipmentStageForm = [
  {
    ...Shipment.no,
    type: T.String,
    value: ''
  },
  {
    ...Shipment.stageNo,
    span: 1,
    type: T.RemoteSelect,
    options: [],
    loading: false,
    method: function (name) {
      const that = this
      that.loading = true
      const query = {
        types: [TypeStage, TypeDock],
        size: -1
      }
      if (name) query.slotFuzzy = name
      queryStackSlots(query).then(res => {
        that.loading = false
        that.options.splice(0, that.options.length)
        that.options.push(
          ...res.records.map(item => ({
            key: item.no,
            label: item.no,
            value: item.no
          }))
        )
      })
    },
    default: '',
    value: '',
    validators: []
  },
  {
    type: T.Checkbox,
    label: 'Force Change Even Prepared',
    key: 'forceUpdate',
    activeText: 'Force',
    value: false,
    default: false,
    validators: []
  }
]

export const ShipmentPickUpdateForm = [
  {
    ...Shipment.no,
    type: T.String,
    value: ''
  },
  {
    ...Shipment.pickUpDate,
    type: T.DateSelect,
    example: '',
    default: '',
    value: '',
    options: [],
    validators: [T.RequiredValidator]
  }
]

export const ShipmentReadyForm = [
  {
    ...Shipment.pickUpNo,
    span: -1,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: []
  },
  {
    ...Shipment.trailerNo,
    span: -1,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: []
  },
  {
    ...Shipment.sealNo,
    span: -1,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: []
  },
  {
    ...Shipment.estDeliveredDate,
    span: -1,
    type: T.DateSelect,
    example: '',
    default: '',
    value: '',
    validators: []
  }
]

export const BillInfoPicks = [
  {
    ...BillInfo.name,
    span: 1,
    type: T.Text
  },
  {
    ...BillInfo.address,
    span: 2,
    type: T.Text
  },
  {
    ...BillInfo.city,
    span: -1,
    type: T.Text
  },
  {
    ...BillInfo.state,
    span: 1,
    type: T.Text
  },
  {
    ...BillInfo.country,
    span: 1,
    type: T.Text
  },
  {
    ...BillInfo.zip,
    span: 1,
    type: T.Text
  },
  {
    ...BillInfo.instruction,
    span: 1,
    type: T.Text
  }
]

export const BillInfoModifyForm = Object.fromEntries(
  [
    {
      ...BillInfo.name,
      span: -1,
      type: T.Text,
      value: ''
    },
    {
      ...BillInfo.address,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...BillInfo.city,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...BillInfo.state,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...BillInfo.country,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...BillInfo.zip,
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...BillInfo.instruction,
      span: -1,
      type: T.TextArea,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    }
  ].map(one => [one.key, one])
)

export const BillInfoWrapUp = T.generateWrapUp(BillInfoPicks)

export const BillOtherInfoGetter = specialInstructions => {
  const curr = []
  specialInstructions.forEach(e => {
    curr.push({
      type: T.String,
      label: e.address + ' Instruction',
      key: e.address.toLowerCase() + 'Instruction',
      span: 1
    })
  })
  curr.push({
    type: T.String,
    label: 'Freight Charge Terms',
    key: 'freightChargeTerms',
    span: 1
  })
  return curr
}

export const BolOtherInfoPicksGetter = specialInstructions => {
  const BolOtherInfo = BillOtherInfoGetter(specialInstructions)
  BolOtherInfo.forEach(e => (e.type = T.Text))
  return BolOtherInfo
}

export const BolOtherInfoWrapUp = specialInstructions =>
  T.generateWrapUp(BolOtherInfoPicksGetter(specialInstructions))

export const BolOtherInfoModifyFormGetter = specialInstructions => {
  const form = []
  const bolOtherInfo = BillOtherInfoGetter(specialInstructions)
  for (let i = 0; i < specialInstructions.length; i++) {
    form.push({
      ...bolOtherInfo[i],
      span: -1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    })
  }
  form.push({
    ...bolOtherInfo[bolOtherInfo.length - 1],
    span: -1,
    type: T.RadioGroup,
    options: [
      {
        value: 'Prepaid',
        label: 'prepaid'
      },
      {
        value: 'Collect',
        label: 'collect'
      },
      {
        value: 'C.O.D.',
        label: 'cod'
      }
    ],
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator]
  })
  return Object.fromEntries(form.map(one => [one.key, one]))
}

// for shipment trucks
export const ShipmentPickUpHeaders = [
  {
    type: T.Link,
    label: 'Shipment#',
    key: 'no',
    link: 'goToShipmentDetail',
    sortable: 'custom',
    defaultSort: true,
    col: 'shipment_no',
    linkKey: 'no',
    width: 100
  },
  {
    label: 'Status',
    key: 'status',
    options: Object.values(ShipmentStatus),
    type: T.Tag,
    effect: 'plain',
    tagType: ShipmentStatusTagType,
    sortable: 'custom',
    col: 'status'
  },
  {
    type: T.SlotType,
    slotName: 'totalPalletCount',
    label: 'Pallets',
    width: 60,
    key: 'palletIds.length'
  },
  {
    type: T.String,
    label: 'Carrier',
    key: 'pickUpInfo.carrierName'
  },
  {
    type: T.String,
    label: 'Driver',
    key: 'pickUpInfo.driverName'
  },
  {
    type: T.String,
    label: 'Phone',
    key: 'pickUpInfo.driverPhone'
  },
  {
    type: T.String,
    label: 'Email',
    key: 'pickUpInfo.driverEmail'
  },
  {
    ...Shipment.sealNo,
    type: T.String
  },
  {
    ...Shipment.trailerNo,
    type: T.String
  },
  {
    type: T.Time,
    label: 'Pick Up Date',
    key: 'pickUpDate'
  }
]

export const ShipmentPickUpInfoSearchForm = [
  {
    label: 'Shipment No.',
    key: 'nos',
    type: T.TextInput,
    inputAccept: 'number',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      if (!value) return ''
      return header.prependValue + value
    },
    prepend: T.PrependSelect,
    prependValue: getYearsPrependOptions('S')[0].value,
    prependOptions: getYearsPrependOptions('S')
  },
  {
    label: 'Container No.',
    key: 'fuzzyContainerNo',
    type: T.TextInput,
    example: 'RII-1234567',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    ...Order.customer,
    key: 'fuzzyCustomer',
    type: T.TextInput,
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  }
]

export const PickUpEmailTemplate = (shipmentNo, driver, qrCode) => {
  // data:image/png;base64
  return `<h2 style="display:flex;align-items:center;justify-content:start"><img width="60px" height="60px" style="border-radius:5px;margin-right:20px"src="data:image/png;base64,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"alt="logo" />RII Shipment Appointment</h2>
<p>Hi ${driver},</p><p>You have successfully sheduled an appointment with Rigel International Inc.</p><p>Here is you pick up information:</p><ul style="width: 600px; border: 1px solid black; padding: 0px !important"><li style="border-bottom: 1px solid black; padding: 10px 20px;margin:0">Date:                <strong></strong></li><li style="border-bottom: 1px solid black; padding: 10px 20px;margin:0">Address:            <strong>14950 Valley View Ave, La Mirada, CA, 90638</strong></li><li style="border-bottom: 1px solid black; padding: 10px 20px;margin:0">Shipment No:     <strong>${shipmentNo}</strong></li><li style="padding: 10px 20px; display: flex; align-items: center;margin:0">QR Code:           <img width="100px" height="100px" src="${qrCode}"/><strong></strong></li></ul>

<p>Please show <strong>Shipment No.</strong> or <strong>QR Code</strong> when picking up at the front.</p>
<p>Best,</p><p>Cindy</p>
`
}

export const ProxyShippingReportPicks = [
  {
    label: 'ARN No.',
    key: 'arnNo',
    span: 1,
    type: T.Text
  },
  {
    label: 'BOL No.',
    key: 'bolNo',
    span: 1,
    type: T.Text
  },
  {
    label: 'Carrier Name',
    key: 'carrierName',
    span: 1,
    type: T.Text
  },
  {
    label: 'Customer Order No.',
    key: 'customerOrderNo',
    span: 1,
    type: T.Text
  },
  {
    label: 'Purchase Order No.',
    key: 'poNo',
    span: 1,
    type: T.Text
  },
  {
    label: 'Seal No.',
    key: 'sealNo',
    span: 1,
    type: T.Text
  },
  {
    label: 'RII Order No.',
    key: 'riiOrderNo',
    span: 1,
    type: T.Text
  },
  {
    label: 'EST Delivery Date',
    key: 'estDeliveredDate',
    span: 1,
    type: T.Text
  }
]

export const ReportBasicWrapUp = T.generateWrapUp(ProxyShippingReportPicks)
